const translations = {
    requiredError: 'User role is required'
};

export default translations;
